<template>
    <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{ padding: '20px' }">
        <a-form class="mb-20" layout="inline" :form="dataForm" @submit="getDataList">
            <a-form-item label="客户名称">
                <a-input v-model="dataForm.customer_name" placeholder="客户姓名" />
            </a-form-item>
            <a-form-item label="项目名称">
                <a-input v-model="dataForm.project_name" style="width: 240px" placeholder="项目名称(非小程序项目名称)" />
            </a-form-item>
            <a-form-item label="指定项目筛选">
                <el-cascader :props="{ checkStrictly: true }" :options="supplierList" @change="changeCascader" clearable
                    :show-all-levels="false" filterable></el-cascader>
            </a-form-item>
            <a-form-item label="评价日期">
                <a-range-picker @change="onChangeTime2" v-model="times" :allowClear="false" value-format="yyyy/MM/DD" />
            </a-form-item>
            <a-form-item label="是否可见">
                <a-select style="width: 120px" v-model="dataForm.commit_show" allowClear placeholder="请选择">
                    <a-select-option value="1">是</a-select-option>
                    <a-select-option value="2">否</a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item label="评分">
                <a-select style="width: 120px" v-model="dataForm.rate" allowClear placeholder="请选择">
                    <a-select-option :value="1">1星</a-select-option>
                    <a-select-option :value="2">2星</a-select-option>
                    <a-select-option :value="3">3星</a-select-option>
                    <a-select-option :value="4">4星</a-select-option>
                    <a-select-option :value="5">5星</a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item>
                <a-button type="primary" @click="getDataList" :loading="dataListLoading">搜索</a-button>
            </a-form-item>
        </a-form>
        <a-table :columns="columns" :data-source="dataList" :pagination="false" rowKey="tripproject_id"
            :loading="dataListLoading" :scroll="{ x: 1500 }">
            <template slot="rate" slot-scope="text, row">
                <a-rate v-model="text" disabled></a-rate>
            </template>
            <template slot="imgs" slot-scope="text, row">
                <img v-for="goods_img in text ? text.split(',') : []" v-if="text" :src="goods_img" alt="" width="50px"
                    height="50px" style="cursor: pointer;margin-right: 5px;object-fit: cover;"
                    @click="preview(goods_img)" />
                <a-tag v-if="!text">未上传</a-tag>
            </template>
            <template slot="commit_show" slot-scope="text, row">
                <a-tag :color="text === '1' ? 'green' : 'red'">{{ text === '1' ? '正常可见' : '不对外可见' }}</a-tag>
            </template>
            <template slot="anonymous" slot-scope="text, row">
                <a-tag :color="text === '1' ? 'green' : 'red'">{{ text === '1' ? '已匿名' : '不匿名' }}</a-tag>
            </template>
            <template slot="editBtn" slot-scope="text, row">
                <a type="link" class="btn-edit" v-permission="[]" @click="addOrUpdateHandle(row.tripproject_id)">
                    编辑评论
                </a>
            </template>
        </a-table>
        <a-pagination class="mt-20 float-right" show-size-changer :current="page" :total="total"
            :show-total="(total) => `共 ${total} 条数据`" @showSizeChange="showSizeChange"
            @change="pageCurrentChangeHandle" />
        <addorupdate ref="addOrUpdate" @ok="getDataList"></addorupdate>
    </a-card>
</template>

<script>
import viewModule from "@/mixins/view-module";
import Addorupdate from "./commitupdate.vue";
// 获取当前月的第一天和最后一天
const now = new Date();
const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);

// 格式化日期为 yyyy/MM/DD
const formatDate = (date) => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}/${month}/${day}`;
};
const basestart = formatDate(firstDay);
const baselast = formatDate(lastDay);

import moment from "moment";
const today_start = moment().format('YYYY-MM-DD 00:00:00')
const today_end = moment().format('YYYY-MM-DD 23:59:59')
export default {
    mixins: [viewModule],
    components: {
        Addorupdate
    },
    props: {
        customer_id: String,
    },
    data() {

        return {
            supplierList: [],
            mixinViewModuleOptions: {
                getDataListURL: "/admin/tripproject/commitpage",
            },
            // times: [basestart, baselast],
            times: [],
            dataForm: {
                // commit_start: basestart,
                // commit_end: baselast,
                commit_start: undefined,
                commit_end: undefined,
                project_name: '',
                customer_name: "",
                process_status: undefined,
                supplier_id: null,
                categorize_id: null,
                goods_id: null,
                commit_show: undefined,
                rate: undefined
            },
            columns: [
                {
                    title: "项目名称",
                    dataIndex: "goods.goods_name",
                    width: 180,
                    ellipsis: true,
                    // fixed: 'left',
                    // align: 'center'
                },
                {
                    title: "小程序项目名称",
                    dataIndex: "goods.goods_appname",
                    width: 180,
                    ellipsis: true,
                    // fixed: 'left',
                    // align: 'center'
                },
                {
                    title: "会员姓名",
                    dataIndex: "trip.customerinfo.customer_name",
                    width: 200,
                },
                {
                    title: "评价内容",
                    dataIndex: "commit",
                    width: 200,
                },
                {
                    title: "评分(1-5)",
                    dataIndex: "rate",
                    scopedSlots: { customRender: "rate" },
                    width: 200,
                },
                {
                    title: "评价图片",
                    dataIndex: "imgs",
                    scopedSlots: { customRender: "imgs" },
                    width: 200,
                },
                {
                    title: "评价时间",
                    dataIndex: "commit_time",
                    width: 180,
                },
                {
                    title: "是否可见",
                    dataIndex: "commit_show",
                    scopedSlots: { customRender: "commit_show" },
                    width: 100,
                },
                {
                    title: "是否匿名",
                    dataIndex: "anonymous",
                    scopedSlots: { customRender: "anonymous" },
                    width: 100,
                },
                {
                    title: "操作",
                    scopedSlots: { customRender: "editBtn" },
                    width: 190,
                    fixed: "right",
                },
            ],
        };
    },
    mounted() {
        this.getSupplierList()
        // 初始化时设置时间范围
        if (this.times && this.times.length === 2) {
            this.dataForm.commit_start = `${this.times[0]} 00:00:00`;
            this.dataForm.commit_end = `${this.times[1]} 23:59:59`;
        }
    },
    methods: {
        preview(url) {
            this.$viewerApi({
                images: [url],
            });
        },
        onChangeTime2(e) {
            if (e.length == 2) {
                this.dataForm.project_start = `${e[0]} 00:00:00`
                this.dataForm.project_end = `${e[1]} 23:59:59`
            } else {
                this.dataForm.project_start = undefined
                this.dataForm.project_end = undefined
            }
        },
        changeCascader(e) {
            this.dataForm.supplier_id = e[0] || null
            this.dataForm.categorize_id = e[1] || null
            this.dataForm.goods_id = e[2] || null
        },
        getSupplierList() {
            this.$http({
                url: "/admin/supplier/goodsChildren",
                method: "get",
            }).then((res) => {
                this.supplierList = res.data;
            });
        },
        TripProjectClick(trip_id) {
            this.$refs.tripProject.init(trip_id);
        },
        filterOption(input, option) {
            return (
                option.componentOptions.children[0].text
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
            );
        },
        //行程信息
        detail(trip_id) {
            this.$refs.tripProject.init(trip_id);
        },
    },
};
</script>

<style></style>